import { defineComponent, computed, ref, openBlock, createElementBlock, normalizeClass, createElementVNode, createVNode, unref, createTextVNode } from "vue";
import GenericMedia from "../GenericMedia/GenericMedia.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BikeMeasurements",
  props: {
    bikeDiagram: {},
    modal: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const wrapperClass = computed(() => props.modal ? "modal-bike-measurements" : "bike-measurements");
    const lazyOpts = ref({
      intersectionRatio: 1e-3,
      threshold: [0.25, 0.5, 0.75, 1]
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(wrapperClass.value)
      }, [_cache[12] || (_cache[12] = createElementVNode("h3", null, "How we measure bikes", -1)), createElementVNode("div", {
        class: normalizeClass(wrapperClass.value + "__content")
      }, [createVNode(unref(GenericMedia), {
        class: normalizeClass(wrapperClass.value + "__image"),
        "aria-hidden": "true",
        "image-src": _ctx.bikeDiagram,
        lazy: true,
        "lazy-opts": lazyOpts.value,
        title: "bike diagram"
      }, null, 8, ["class", "image-src", "lazy-opts"]), createElementVNode("ol", {
        class: normalizeClass(wrapperClass.value + "__list")
      }, [createElementVNode("li", {
        class: normalizeClass(wrapperClass.value + "__list-item")
      }, _cache[0] || (_cache[0] = [createTextVNode(" Standover Height "), createElementVNode("span", {
        class: "pdp-sr-only"
      }, " Standover Height is a measurement from the ground to the top of the top tube, measured at the midpoint of the top tube. ", -1)]), 2), createElementVNode("li", {
        class: normalizeClass(wrapperClass.value + "__list-item")
      }, _cache[1] || (_cache[1] = [createTextVNode(" Reach "), createElementVNode("span", {
        class: "pdp-sr-only"
      }, " Reach is the horizontal distance from the center of the cranks to the center of the head tube, measured at head tube level. ", -1)]), 2), createElementVNode("li", {
        class: normalizeClass(wrapperClass.value + "__list-item")
      }, _cache[2] || (_cache[2] = [createTextVNode(" Stack "), createElementVNode("span", {
        class: "pdp-sr-only"
      }, " Stack is the vertical distance from the center of the cranks to the center of the head tube, measured to the top of the head tube. ", -1)]), 2), createElementVNode("li", {
        class: normalizeClass(wrapperClass.value + "__list-item")
      }, _cache[3] || (_cache[3] = [createTextVNode(" Effective Top Tube "), createElementVNode("span", {
        class: "pdp-sr-only"
      }, " Effective top tube is the distance from the center of the head tube to the center of the seat tube/seat post, measured parallel to the ground. ", -1)]), 2), createElementVNode("li", {
        class: normalizeClass(wrapperClass.value + "__list-item")
      }, _cache[4] || (_cache[4] = [createTextVNode(" Seat Tube Center to Top "), createElementVNode("span", {
        class: "pdp-sr-only"
      }, " Seat Tube length is the measurement of the seat tube, from the center of the cranks to the top of the seat tube. ", -1)]), 2), createElementVNode("li", {
        class: normalizeClass(wrapperClass.value + "__list-item")
      }, _cache[5] || (_cache[5] = [createTextVNode(" Head Tube Length "), createElementVNode("span", {
        class: "pdp-sr-only"
      }, " Head Tube Length is measured from the bottom to the top of the head tube. ", -1)]), 2), createElementVNode("li", {
        class: normalizeClass(wrapperClass.value + "__list-item")
      }, _cache[6] || (_cache[6] = [createTextVNode(" Head Tube Angle "), createElementVNode("span", {
        class: "pdp-sr-only"
      }, " Head Tube Angle is the acute angle between the head tube and the ground (measured towards the rear of the bike) ", -1)]), 2), createElementVNode("li", {
        class: normalizeClass(wrapperClass.value + "__list-item")
      }, _cache[7] || (_cache[7] = [createTextVNode(" Seat Tube Angle "), createElementVNode("span", {
        class: "pdp-sr-only"
      }, " Seat Tube Angle is the acute angle between the seat tube and the ground (measured towards the rear of the bike). ", -1)]), 2), createElementVNode("li", {
        class: normalizeClass(wrapperClass.value + "__list-item")
      }, _cache[8] || (_cache[8] = [createTextVNode(" Bottom Bracket Height "), createElementVNode("span", {
        class: "pdp-sr-only"
      }, " Bottom Bracket Height is a measurement taken vertically from the ground up to the center of the cranks. ", -1)]), 2), createElementVNode("li", {
        class: normalizeClass(wrapperClass.value + "__list-item")
      }, _cache[9] || (_cache[9] = [createTextVNode(" Wheelbase "), createElementVNode("span", {
        class: "pdp-sr-only"
      }, " Wheelbase is the measurement from the center of the front axle to the center of the rear axle. ", -1)]), 2), createElementVNode("li", {
        class: normalizeClass(wrapperClass.value + "__list-item")
      }, _cache[10] || (_cache[10] = [createTextVNode(" Chainstay Length "), createElementVNode("span", {
        class: "pdp-sr-only"
      }, " Chainstay Length is the measurement from the center of the cranks to the center of the rear axle. ", -1)]), 2), createElementVNode("li", {
        class: normalizeClass(wrapperClass.value + "__list-item")
      }, _cache[11] || (_cache[11] = [createTextVNode(" Fork Offset "), createElementVNode("span", {
        class: "pdp-sr-only"
      }, " Fork Offset, or rake, is the distance from the front axle to a line drawn parallel to the center of the head tube or steering axis. ", -1)]), 2)], 2)], 2)], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BikeMeasurements2.mjs.map
